<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.goods.search.category')" prop="categoryId">
                <a-select
                  v-model="queryParam.categoryId"
                  show-search
                  allow-clear
                  :loading="categoryLoading"
                  :placeholder="$t('views.goods.search.categoryPlaceholder')"
                  :filter-option="filterCategoryOption"
                >
                  <a-select-option
                    v-for="item in categoryOptions"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.goods.search.name')" prop="name">
                <a-input v-model="queryParam.name" :placeholder="$t('views.goods.search.namePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.goods.search.type')" prop="type">
                <a-select
                  v-model="queryParam.type"
                  allow-clear
                  :placeholder="$t('views.goods.search.typePlaceholder')"
                >
                  <a-select-option :value="0">{{ $t('views.goods.type.0') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('views.goods.type.1') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="图标" prop="url">
                  <a-input v-model="queryParam.url" placeholder="请输入图标" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="描述" prop="description">
                  <a-input v-model="queryParam.description" placeholder="请输入描述" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="排序" prop="sort">
                  <a-input v-model="queryParam.sort" placeholder="请输入排序" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            -->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.goods.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.goods.btn.reset') }}</a-button>
                <!--
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
                -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:goods:add']">
          <a-icon type="plus" />{{ $t('views.goods.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:goods:edit']">
          <a-icon type="edit" />{{ $t('views.goods.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:goods:remove']">
          <a-icon type="delete" />{{ $t('views.goods.btn.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 同类选择管理（右侧抽屉） -->
      <a-drawer
        :visible="goodsSpecSameDrawerOpen"
        placement="right"
        width="85%"
        :destroyOnClose="true"
        @close="closeGoodsSpecSameDrawer"
      >
        <template slot="title">
          {{ $t('views.goods.drawer.specSameTitle') }}
        </template>
        <goods-spec-same
          ref="goodsSpecSame"
          :drawer="true"
          :good-id="currentGoodsId"
        />
      </a-drawer>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="type" slot-scope="text, record">
          {{ formatGoodsType(record.type) }}
        </span>
        <span slot="imgUrl" slot-scope="text, record">
          <a-space v-if="record && record.imgUrl" :size="6">
            <img
              v-for="(img, idx) in String(record.imgUrl).split(',').map(s => (s || '').trim()).filter(Boolean)"
              :key="idx"
              style="width: 48px;height: 48px;"
              v-image-preview
              :src="img"
            >
          </a-space>
        </span>
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            :disabled="!canEdit"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            :disabled="!canEdit"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:goods:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:goods:edit']">
            <a-icon type="edit" />{{ $t('views.goods.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:goodsSpecSame:list']" />
          <a @click="openGoodsSpecSameDrawer(record)" v-hasPermi="['user:goodsSpecSame:list']">
            <a-icon type="unordered-list" /> {{ $t('views.goods.action.specSameManage') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:goods:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:goods:remove']">
            <a-icon type="delete" />{{ $t('views.goods.btn.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageGoods,listGoods, delGoods, updateGoods, updateGoodsSort, updateGoodsStatus } from '@/api/user/goods'
import CreateForm from './modules/CreateForm'
import { listCategory } from '@/api/user/category'
import GoodsSpecSame from '../goodsSpecSame/index.vue'
import { tableMixin } from '@/store/table-mixin'
import auth from '@/plugins/auth'

export default {
  name: 'Goods',
  components: {
    CreateForm,
    GoodsSpecSame
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      categoryLoading: false,
      categoryOptions: [],
      goodsSpecSameDrawerOpen: false,
      currentGoodsId: null,
      // 查询参数
      queryParam: {
        categoryId: null,
        name: null,
        type: null,
        url: null,
        description: null,
        content: null,
        sort: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: []
    }
  },
  filters: {
  },
  created () {
    this.buildColumns()
    this.loadCategoryOptions()
    this.getList()
  },
  computed: {
    /** 与 v-hasPermi="['user:goods:edit']" 一致，用于行内排序/状态 */
    canEdit () {
      return auth.hasPermi('user:goods:edit')
    }
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    }
  },
  methods: {
    buildColumns () {
      const t = k => this.$t(k)
      this.columns = [
        { title: t('views.goods.column.id'), dataIndex: 'id', ellipsis: true, align: 'center' },
        { title: t('views.goods.column.categoryName'), dataIndex: 'categoryName', ellipsis: true, align: 'center' },
        { title: t('views.goods.column.name'), dataIndex: 'name', ellipsis: true, align: 'center' },
        {
          title: t('views.goods.column.type'),
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.goods.column.imgUrl'),
          dataIndex: 'imgUrl',
          scopedSlots: { customRender: 'imgUrl' },
          ellipsis: true,
          align: 'center'
        },
        { title: t('views.goods.column.description'), dataIndex: 'description', ellipsis: true, align: 'center' },
        { title: t('views.goods.column.content'), dataIndex: 'content', ellipsis: true, align: 'center' },
        {
          title: t('views.goods.column.sort'),
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.goods.column.status'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.goods.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.goods.column.operation'),
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    paginationShowTotal (total) {
      return this.$t('views.goods.pagination.total', { total })
    },
    filterCategoryOption (input, option) {
      const text = option && option.componentOptions && option.componentOptions.children && option.componentOptions.children[0] && option.componentOptions.children[0].text
      return (text || '').toLowerCase().includes((input || '').toLowerCase())
    },
    formatGoodsType (type) {
      if (type === 1 || type === '1') {
        return this.$t('views.goods.type.1')
      }
      return this.$t('views.goods.type.0')
    },
    loadCategoryOptions () {
      if (this.categoryLoading) return
      this.categoryLoading = true
      listCategory({}).then(res => {
        const data = (res && res.data) || []
        this.categoryOptions = Array.isArray(data) ? data : []
      }).finally(() => {
        this.categoryLoading = false
      })
    },
    /** 查询产品列表 */
    getList () {
      this.loading = true
     pageGoods(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        categoryId: undefined,
        name: undefined,
        type: undefined,
        url: undefined,
        description: undefined,
        content: undefined,
        sort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('views.goods.confirm.deleteTitle'),
        content: this.$t('views.goods.confirm.deleteContent', { ids }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delGoods(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.goods.msg.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: that.$t('views.goods.confirm.exportTitle'),
        content: that.$t('views.goods.confirm.exportContent'),
        onOk () {
          that.download('user/goods/export', {
            ...that.queryParam
          }, that.$t('views.goods.export.filename', { time: new Date().getTime() }))
        },
        onCancel () {}
      })
    },
    /** 状态开关变更 */
    handleStatusChange (record, checked) {
      if (!this.canEdit) {
        return
      }
      const statusValue = checked ? 1 : 0
      updateGoodsStatus({ id: record.id, status: statusValue }).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.goods.msg.statusOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.goods.msg.statusFail'))
      })
    },
    /** 排序值变更 */
    handleSortChange (record, value, fieldName) {
      if (!this.canEdit) {
        return
      }
      if (value === null || value === undefined) {
        return
      }
      updateGoodsSort({ id: record.id, sort: value }).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.goods.msg.sortOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.goods.msg.sortFail'))
      })
    },
    openGoodsSpecSameDrawer (record) {
      const id = record && record.id ? record.id : null
      this.currentGoodsId = id
      this.goodsSpecSameDrawerOpen = true
    },
    closeGoodsSpecSameDrawer () {
      this.goodsSpecSameDrawerOpen = false
      this.currentGoodsId = null
    }
  }
}
</script>
